import React  from 'react';
function TradeZakatTable({ result}) {
  return (
    <table >
      <thead>
        <tr>
          <th >Condition</th>
          <th > Résultats</th>
        </tr>
      </thead>
      <tbody>
        <tr >
          <td>Obligation de Zakat	</td>
          <td>{result.silverZakatDuty === 'yes' ? 'Zakat obligatoire' : 'Zakat non obligatoire'}</td>
        </tr>
        <tr >
          <td> Total de l'argent</td>
          <td>{result.moneyAmout} </td>
        </tr>
        <tr >
          <td>Seuil de Zakat sur l'argent</td>
          <td>{result.threshold}  </td>
        </tr>
        <tr >
          <td>Montant de Zakat à payer (en espèces)</td>
          <td>{result.tradeZakat} </td>
        </tr>
      </tbody>
    </table>
  );
}
export default TradeZakatTable;
